/**
 * Rebuy Smart Cart: collapse discount form behind "Have a code?" until expanded.
 * Re-runs on cart lifecycle events and cart DOM mutations (Vue re-renders).
 */
(function () {
  'use strict';

  var COLLAPSED = 'dadbrand-rebuy-discount--collapsed';
  var BTN_CLASS = 'dadbrand-rebuy-discount-toggle';
  var OPEN_DATA = 'data-dadbrand-discount-open';

  function discountInputEnabled() {
    try {
      var fn = window.Rebuy && window.Rebuy.SmartCart && window.Rebuy.SmartCart.isDiscountInputEnabled;
      if (typeof fn === 'function') return fn.call(window.Rebuy.SmartCart) !== false;
    } catch (_e) {
      /* ignore */
    }
    return true;
  }

  function findDiscountRoots() {
    var byData = document.querySelectorAll('[data-rebuy-component="discount-input"]');
    if (byData.length) return byData;
    return document.querySelectorAll('.rebuy-cart__flyout-discount-container');
  }

  function hasAppliedCode(root) {
    return !!root.querySelector('.rebuy-cart__flyout-discount-tag');
  }

  function getCodeInput(root) {
    return root.querySelector('#rebuy-discount-input') || root.querySelector('input.rebuy-input');
  }

  function ensureToggle(root) {
    var btn = root.querySelector('.' + BTN_CLASS);
    if (btn) return btn;
    if (!root.querySelector('form')) return null;
    btn = document.createElement('button');
    btn.type = 'button';
    btn.className = BTN_CLASS;
    btn.setAttribute('aria-controls', 'rebuy-discount-input');
    root.insertBefore(btn, root.firstChild);
    return btn;
  }

  function setToggleLabel(btn, collapsed) {
    btn.textContent = collapsed ? 'Have a code?' : 'Hide';
    btn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
  }

  function syncRoot(root) {
    if (!discountInputEnabled()) {
      root.classList.remove(COLLAPSED);
      var t = root.querySelector('.' + BTN_CLASS);
      if (t) t.remove();
      root.removeAttribute(OPEN_DATA);
      return;
    }

    var applied = hasAppliedCode(root);
    var input = getCodeInput(root);
    var hasValue = !!(input && String(input.value || '').trim());
    var btn = ensureToggle(root);
    if (!btn) return;

    if (applied) {
      root.classList.remove(COLLAPSED);
      root.removeAttribute(OPEN_DATA);
      btn.hidden = true;
      return;
    }

    btn.hidden = false;

    if (hasValue) {
      root.classList.remove(COLLAPSED);
      root.setAttribute(OPEN_DATA, '1');
      setToggleLabel(btn, false);
      return;
    }

    if (root.getAttribute(OPEN_DATA) === '1') {
      root.classList.remove(COLLAPSED);
      setToggleLabel(btn, false);
      return;
    }

    root.classList.add(COLLAPSED);
    root.removeAttribute(OPEN_DATA);
    setToggleLabel(btn, true);
  }

  function initDiscountDisclosure() {
    var roots = findDiscountRoots();
    for (var i = 0; i < roots.length; i++) {
      syncRoot(roots[i]);
    }
  }

  var debounceTimer;
  function debouncedInit() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(initDiscountDisclosure, 40);
  }

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest('.' + BTN_CLASS);
      if (!btn || btn.hidden) return;
      var root =
        btn.closest('[data-rebuy-component="discount-input"]') ||
        btn.closest('.rebuy-cart__flyout-discount-container');
      if (!root) return;
      e.preventDefault();
      if (hasAppliedCode(root)) return;
      var collapsed = root.classList.contains(COLLAPSED);
      if (collapsed) {
        root.classList.remove(COLLAPSED);
        root.setAttribute(OPEN_DATA, '1');
        var input = getCodeInput(root);
        if (input) {
          try {
            input.focus();
          } catch (_e) {
            /* ignore */
          }
        }
      } else {
        root.classList.add(COLLAPSED);
        root.removeAttribute(OPEN_DATA);
      }
      setToggleLabel(btn, root.classList.contains(COLLAPSED));
    },
    false
  );

  function boot() {
    initDiscountDisclosure();
    document.addEventListener('rebuy:cart.ready', debouncedInit);
    document.addEventListener('rebuy:cart.change', debouncedInit);
    document.addEventListener('rebuy.loaded', debouncedInit);
    document.addEventListener('input', debouncedInit, true);

    var cartEl = document.querySelector('.rebuy-cart');
    if (cartEl) {
      new MutationObserver(debouncedInit).observe(cartEl, { childList: true, subtree: true });
    } else {
      var moTimer = setInterval(function () {
        var c = document.querySelector('.rebuy-cart');
        if (c) {
          clearInterval(moTimer);
          new MutationObserver(debouncedInit).observe(c, { childList: true, subtree: true });
          debouncedInit();
        }
      }, 500);
      setTimeout(function () {
        clearInterval(moTimer);
      }, 15000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
